import BaseLayout from '@/components/BaseLayout.vue'
import api from '@/services/api';

export default {
    name: 'education-tests-archive',

    data() {
        return {
            quizzes: [],
        };
    },

    components: {
        BaseLayout
    },

    methods: {
        /**
         * Get education quizzes from API
         */
        getQuizzes() {
            api.get('/api/get_archived_promotion_education_quizzes')
                .then((response) => {
                    this.quizzes = response.data.body.entries
                });
        },
    },

    watch: {
        'user.pcmsId': function (){
            this.getQuizzes();
        }
    },

    mounted() {
        this.getQuizzes();
    },
}
